function dataURLToFile(file, prefix = null) {
  const { url, name, type } = file
  const arr = url.split(',')
  // Extract MIME type from the data URL header (e.g. "data:image/png;base64").
  // Fall back to file.type for cases where the URL doesn't carry a MIME prefix.
  const mimeMatch = arr[0].match(/:(.*?);/)
  const mime = mimeMatch ? mimeMatch[1] : type
  const bstr = Buffer.from(arr[1], 'base64')
  const u8arr = new Uint8Array(bstr)
  const newFileName = prefix ? `${prefix}_${name}` : name
  return new File([u8arr], newFileName, { type: mime })
}

export default dataURLToFile
